"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.scrollNextItemIntoViewY = void 0;
var _scrollToFullyVisibleY = require("../../../dom/scrollToFullyVisibleY");
var scrollNextItemIntoViewY = exports.scrollNextItemIntoViewY = function scrollNextItemIntoViewY(metas, next) {
  var container = metas.container,
    nextElement = metas.nextElement;
  if (container && nextElement) {
    (0, _scrollToFullyVisibleY.scrollToFullyVisibleY)({
      container: container,
      element: nextElement
    });
  }
  next(metas);
};